import React, { Fragment, LegacyRef } from "react";
import { Menu, Transition } from "@headlessui/react";
import Link from "next/link";
import { MdOutlineOndemandVideo } from "react-icons/md";

import useAreThereWhatsNewUpdates from "./hooks/useAreThereWhatsNewUpdates";

import Typography from "../../common/Typography/Typography";
import Icon from "../../common/Icon/Icon";
import styles from "./HelpDropdown.module.css";
import { PDF_USER_GUIDE, VIDEO_USER_GUIDE } from "../../../config/global.config";
import TakeTheTourModal from "../../TakeTheTourModal/TakeTheTourModal";

const HelpDropdown = () => {
    const areThereWhatsNewUpdates = useAreThereWhatsNewUpdates();

    return (
        <Menu as="div" className="min-[1130px]:block relative">
            {({ open }) => (
                <Fragment>
                    <Menu.Button className={`${styles.helpDropdownTrigger} ${open ? styles.helpDropdownTriggerActive : ""}`}>
                        {areThereWhatsNewUpdates ? <div className={`${styles.alert} ${styles.alertHelp}`} /> : null}
                        <Icon icon="help_outline" width={21} height={21} className="shrink-0" />
                    </Menu.Button>
                    <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                    >
                        <Menu.Items className={`${styles.helpDropdown} divide-y divide-pine-900`}>
                            <div className={styles.helpDropdownGroup}>
                                <Menu.Item>
                                    <Link href="/request-a-feature" className={styles.helpDropdownItem}>
                                        <Icon icon="chat_bubble" width={17.5} />
                                        <Typography color="midnight" variant="meta">
                                            Request a feature
                                        </Typography>
                                    </Link>
                                </Menu.Item>
                                <Menu.Item>
                                    <Link href="/whats-new" className={styles.helpDropdownItem}>
                                        <Icon icon="stamp" width={17.5} />
                                        <Typography variant="meta" color="midnight" className="flex items-center gap-0.5">
                                            What's new
                                            {areThereWhatsNewUpdates ? <span className={`${styles.alert} ${styles.alertInline}`} /> : null}
                                        </Typography>
                                    </Link>
                                </Menu.Item>
                                <Menu.Item>
                                    <Link
                                        href={PDF_USER_GUIDE}
                                        className={styles.helpDropdownItem}
                                        download
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <Icon icon="file_pdf" width={17.5} />
                                        <Typography variant="meta" color="midnight">
                                            PDF user guide
                                        </Typography>
                                    </Link>
                                </Menu.Item>
                                {VIDEO_USER_GUIDE && (
                                    <Menu.Item>
                                        <TakeTheTourModal tour="fullvideoguide">
                                            {({ openModal, forwardedRef }) => (
                                                <button
                                                    ref={forwardedRef as LegacyRef<HTMLButtonElement> | undefined}
                                                    type="button"
                                                    className={`${styles.helpDropdownItem} w-full`}
                                                    onClick={openModal}
                                                >
                                                    <MdOutlineOndemandVideo className="text-400" />
                                                    <Typography variant="meta" color="midnight">
                                                        Video user guide
                                                    </Typography>
                                                </button>
                                            )}
                                        </TakeTheTourModal>
                                    </Menu.Item>
                                )}
                            </div>
                        </Menu.Items>
                    </Transition>
                </Fragment>
            )}
        </Menu>
    );
};

export default HelpDropdown;
